export default "__VITE_ASSET__BrdOiv$b__"